import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchUserDetailsByNetId, updateUserDetails } from '../services/api';



function UserEdit() {
    const { netId } = useParams();
    const navigate = useNavigate();
    const [user, setUser] = useState({
        firstName: '',
        lastName: '',
        department: '',
        boxNumber: '',
        phone: '',
    });
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchUserDetailsByNetId(netId).then(data => {
            setUser(data);
            setIsLoading(false);
        });
    }, [netId]);

    const handleChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await updateUserDetails(netId, user);
            navigate(`/user/${netId}`);
        } catch (error) {
            console.error('Failed to update user:', error.message);
            setError('Failed to update user: ' + error.message);
        }
    };

    if (isLoading) return <div>Loading...</div>;

    return (
        <div className="container mt-4">
            <div className='page-header'>
                <h1 className='gradient-under'>Edit User {user.netId}</h1>
            </div>
            <form onSubmit={handleSubmit} className="mt-3">
                <div className="mb-3">
                    <label htmlFor="firstName" className="form-label">First Name</label>
                    <input type="text" className="form-control" id="firstName" name="firstName" value={user.firstName || ''} onChange={handleChange} />
                </div>
                <div className="mb-3">
                    <label htmlFor="lastName" className="form-label">Last Name</label>
                    <input type="text" className="form-control" id="lastName" name="lastName" value={user.lastName || ''} onChange={handleChange} />
                </div>
                <div className="mb-3">
                    <label htmlFor="department" className="form-label">Department</label>
                    <input type="text" className="form-control" id="department" name="department" value={user.department || ''} onChange={handleChange} />
                </div>
                <div className="mb-3">
                    <label htmlFor="boxNumber" className="form-label">Box Number</label>
                    <input type="text" className="form-control" id="boxNumber" name="boxNumber" value={user.boxNumber || ''} onChange={handleChange} />
                </div>
                <div className="mb-3">
                    <label htmlFor="phone" className="form-label">Phone <em>(10-digit numbers only, no symbols)</em></label>
                    <input type="tel" className="form-control" id="phone" name="phone" pattern="[0-9]{10}" value={user.phone || ''} onChange={handleChange} />
                </div>
                <button type="submit" className="btn btn-primary">Update User</button>
                
            </form>
        </div>
    );

}

export default UserEdit;
